
<template>

  <div class="atividades-rfilancamentos ml-4 mr-4" >
      <b-form>          
          <b-row>
              

              <LoadingModal v-if="isLoading" />

              <b-col cols="10" >
                <label  for="input-busca">Pesquisa no grid  </label>  
                <b-form-input id="buscamonitoramento" v-model="search"  required="required" placeholder="Códgio ERP / Descrição"></b-form-input>              
              </b-col>                 


              <b-col cols="2">
                <br>
                <b-button variant="warning"  block class="mt-2 mr-2 " v-b-modal.ModaleditarProduto >Novo Produto</b-button>
              </b-col>

          </b-row>
    </b-form>

    
    <div class="d-flex justify-content-center mb-3">
      <b-spinner v-if="atualizando" label="Loading..."></b-spinner>
    </div>    
    <!--tbl de dados -->
        <b-table small hover striped sticky-header="762px"  :items="itemsFiltered" :fields="fieldsCliFor">                  
        <template slot="cell(actions)" slot-scope="data">
          <b-button  @click="putProduto(data.item)"    title="Editar produto"  size="sm" variant="primary" class="mr-2 mt-2" v-b-modal.ModaleditarProduto>                
            <i class="fa fa-pencil"></i>              
          </b-button> 
        </template>
    </b-table>
    <b-pagination size="xl" v-model="page" :total-rows="count" :per-page="limitcarro"></b-pagination>
    

      <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
      <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
      <div>        
    <b-modal id="ModaleditarProduto" centered cancel-title="Fechar"  @cancel="loadCliGrid()"  @close="loadCliGrid()" hide-footer size="xl" title="Cadastro de produtos"  no-close-on-esc no-close-on-backdrop>
          <!-- -->
          <div>

          

            <b-row> 
           
            <b-col cols="3"  class="mb-2 mt-6">
                <label for="input-registro">Código ERP</label> 
                <b-form-input  @keyup.enter="loadCliFor()" v-model="produto.codigo_erp" required placeholder="Nº do produto" v-b-tooltip.hover title="Digite o códio do produto"></b-form-input>              
            </b-col>             

<b-col cols="9"  class="mb-2">
    <label for="input-live">Descrição</label>  
    <b-form-input v-model="produto.descricao" placeholder="Digite a descrição do produto"></b-form-input>              
</b-col>

<!-- endereço  -->
            <b-col cols="4"  class="mb-2 mt-6">
                <label for="input-registro">Códgio produção</label> 
                <b-form-input v-model="produto.codigo_producao" required placeholder="Informe o código de produção" v-b-tooltip.hover title="Digite o código de produção do fabricante"></b-form-input>              
            </b-col>             

<b-col cols="4"  class="mb-2">
    <label for="input-live">Referência</label>  
    <b-form-input v-model="produto.referencia" placeholder="Digite a referência do fabricante"></b-form-input>              
</b-col>

<b-col cols="2" class="mb-2 mt-6">
      <label for="input-registro">Valor de Custo</label> 
      <NumericInput
        v-model="produto.valor_custo"  
        placeholder=""
        title="Digite o valor de custo do produto"
        
      />
    </b-col>

    <b-col cols="2" class="mb-2 mt-6">
      <label for="input-registro">Valor de Venda</label> 
      <NumericInput
        v-model="produto.valor_venda"  
        placeholder=""
        title="Digite o valor de venda do produto"
        
      />
    </b-col>  


                          <b-col cols="6">
                <label for="input-status">Cor</label> 
                <div>                
                  <b-form-select                  
                    v-model="produto.cor_id"  
                    required                                                   
                    :options="cores"
                    class="mb-3"
                    text-field="cor"                            
                  >                   
                  </b-form-select>
                </div>
              </b-col> 

              <b-col cols="6">
                <label for="input-status">Tamanho</label> 
                <div>                
                  <b-form-select                  
                    v-model="produto.tamanho_id"  
                    required                                                   
                    :options="tamanhos"
                    class="mb-3"
                    text-field="tamanho"                            
                  >                   
                  </b-form-select>
                </div>
              </b-col>

    


 


            </b-row> 

            <b-row   class=" mt-2 mb-2">                                    
        
            </b-row>   


            <b-row class="mt-2">

              <b-col cols="3">
                <label for="input-live">DATA CADASTRO</label>                 
                <b-input-group-text >{{ produto.dt_cadastro !=null ? moment(produto.dt_cadastro).format('DD/MM/YYYY HH:mm').replace('Data inválida','-') : '-' }}</b-input-group-text>
              </b-col> 

              <b-col cols="3">
                <label for="input-live">DATA ALTERAÇÃO</label>                 
                <b-input-group-text >{{produto.dt_cadastro !=null ? moment(produto.dt_alteracao).format('DD/MM/YYYY HH:mm').replace('Data inválida','-') :'-' }}</b-input-group-text>
              </b-col> 


              
            <b-col cols="6"  class="mb-2">
                <label for="input-live">Observações</label> 
                <b-form-input v-model="produto.contato" placeholder="Obs "></b-form-input>              
            </b-col>







            </b-row> 

             <b-button class="mt-3" variant="success" block  @click=" postProduto()">Gravar</b-button>
            
          </div>
          
        </b-modal>
      </div>
      <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
  </div>  

</template>


<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import moment from 'moment'
import { mapState } from 'vuex' 
import LoadingModal from '../utilitarios/LoadingModal'
import NumericInput from '../utilitarios/NumericInput';

export default {

  computed : { ... mapState (['user'],),

      getStyle() {
      return {
        color: this.resultadocnpj.situacao !== 'ATIVA' && this.resultadocnpj.situacao !=null ? 'red' : '', // Fonte vermelha se não for 'ATIVA'
        background: this.resultadocnpj.situacao !== 'ATIVA' && this.resultadocnpj.situacao !=null ? 'yellow' : '', // Background amarelo se não for 'ATIVA'
      };
    },


  itemsFiltered(){
        let valorefu = [];       
        valorefu = this.produtos.filter((item) =>{
          const nome = item.descricao || ''; // devido alguns valores retornarem null se faz necessario a substituição para não dar erro no filtro
          const cnpj = item.codigo_erp || '';          
          return (
             nome.indexOf(this.search) >-1  ||             
             cnpj.indexOf(this.search) >-1 
          );
        });
        return valorefu
        }

  } ,

    name: 'FuncionarioCadastro',    

    data: function() {
      
        return {
          produto:{},
          produtos:[],
          cores:[],
          tamanhos:[],
          empresa:{}, 
          empresas:[],   // [] lista       
          filial:{}, 
          filiais: [],   // [] lista      
          clifors:[],
          clifor:{},          
          ceps:[],
          resultadocnpj:{},
          value_cnpj:'',
          areas:[],
          tipos:[],
          escritorios:[],
          search:'',
/*
            mode: 'save',
            carregando: false,
            atualizando: false,              
            page: 1,
            limitcarro: 0,
            count: 0,
            valor_empresa:'',                                     
            selected: null,
  */          
            fieldsCliFor: [                
                { key: 'codigo_erp', label: 'Codigo ERP', sortable: true },                 
                { key: 'codigo_producao', label: 'Código produção', sortable: true },                       
                { key: 'descricao', label: 'Descrição', sortable: true },                 
                { key: 'cor', label: 'Cor', sortable: true },
                { key: 'tamanho', label: 'Tamanho', sortable: true },
                { key: 'valor_custo', label: 'R$ Custo', sortable: true },
                { key: 'valor_venda', label: 'R$ Venda', sortable: true },                
                { key: 'dt_cadastro', label: 'Data cadastro', sortable: true, formatter: (value, key, itemsFiltered) => {
                    return moment(itemsFiltered.dt_cadastro).format('DD/MM/YYYY HH:MM').replace('Data inválida','-') ; }  },                
               { key: 'dt_alteracao', label: 'Data alteração', sortable: true, formatter: (value, key, itemsFiltered) => {
                    return moment(itemsFiltered.dt_alteracao).format('DD/MM/YYYY HH:MM').replace('Data inválida','-') ; }  },         
                { key: 'actions', label: 'Ações' },                
            ]
        }        
    },

    components: {
        Multiselect, LoadingModal,NumericInput
    },

    methods: {

      handleOk(bvModalEvent) {
        // Prevent modal from closing
        bvModalEvent.preventDefault()
        // Trigger submit handler
        this.handleSubmit()
      },

            loadEmpresas() {
            let corpo = {    
                "empresa_id": `${this.user.id_grupo_empresa}`,                                            
            };

          const url = `${baseApiUrl}/jb/controle/empresa`
          axios.post(url,corpo).then(res => {
            this.empresas = res.data.map(emp => {              
              return { id_empresa: emp.id_empresa, empresa: emp.empresa }
            })
          })
      },  



        loadCor() {          
            let corpo = {    
                "filtro": 'cores',                                            
            };            
          const url = `${baseApiUrl}/sambaiba/cf7/produto`
          axios.post(url,corpo)
          .then(res => {this.cores = res.data.map(emp => {return { ... emp, value: emp.id, cor: emp.cor} })})
          .catch(showError)
        },

        loadTamanho() {          
            let corpo = {    
                "filtro": 'tamanho',                                            
            };            
          const url = `${baseApiUrl}/sambaiba/cf7/produto`
          axios.post(url,corpo)
          .then(res => {this.tamanhos = res.data.map(emp => {return { ... emp, value: emp.id, tamanho: emp.tamanho} })})
          .catch(showError)
        },

        loadEscritório() {          
            let corpo = {    
                "id_grupo_empresa": `${this.user.id_grupo_empresa}`,                                            
            };            
          const url = `${baseApiUrl}/jb/fin/escritoriojur`
          axios.post(url,corpo)
          .then(res => {this.escritorios = res.data.map(emp => {return { ... emp, value: emp.id, area: emp.escritorio} })})
          .catch(showError)
        },


        async consultarCNPJ() {     
            
                  let corpo = {    
                        "cnpj": `${this.value_cnpj}`                
                    };

                  const url = await `${baseApiUrl}/cnpj`
                  axios.post(url,corpo)
                      .then(res => {this.resultadocnpj = res.data})                   
                      .catch(showError)                       
        },




        async loadCep() {  
          let corpo = {    
                "cep": `${this.clifors.cnpj}`                
            };
          const url = await`${baseApiUrl}/viacep`
          axios.post(url,corpo)
               .then(res => {this.ceps = res.data})         
              .catch(showError)                      
          
        }, 

      putProduto(produtos) {            
            this.produto = { 
              id: produtos.id,
              codigo_erp: produtos.codigo_erp,
              descricao: produtos.descricao,
              codigo_producao: produtos.codigo_producao,
              referencia: produtos.referencia,              
              valor_custo: produtos.valor_custo * 100,
              valor_venda: produtos.valor_venda * 100,
              cor_id: produtos.cor_id,
              tamanho_id: produtos.tamanho_id,
              observacao: produtos.observacao
             }
      },

      async loadCliFor() {  
          let corpo = {    
            "empresa_id": `${this.user.id_empresa}`,   
            "cnpj": `${this.resultadocnpj.cnpj}`,
            "filtro": 'porcnpj'
          };
          const url = await`${baseApiUrl}/jb/fin/clifor`
          axios.post(url,corpo)
               .then(res => {this.resultadocnpj = res.data})         
              .catch(showError)  
      }, 

      async loadCliGrid() {  
          let corpo = {    
            "empresa_id": `${this.user.id_empresa}`,
            "filtro": 'COMPLETO'
          };
          const url = await`${baseApiUrl}/sambaiba/cf7/produto`
          axios.post(url,corpo)
               .then(res => {this.produtos = res.data})         
              .catch(showError)                                
      }, 
      


      postProduto() {   
            let corpo = {  
                "empresa_id": `${this.user.id_grupo_empresa}`,                 
                "filial_id": `${this.user.id_filial_erp}`,                 
                "id": `${this.produto.id}`,    
                "codigo_erp": `${this.produto.codigo_erp}`,                                           
                "descricao": `${this.produto.descricao}`,   
                "codigo_producao": `${this.produto.codigo_producao}`,                                           
                "referencia": `${this.produto.referencia}`,                                           
                "valor_custo": `${this.produto.valor_custo / 100  }`,                                           
                "valor_venda": `${this.produto.valor_venda /100}`,                                                             // pegar o valor da filial     
                "observacao": `${this.produto.observacao}`,                                                                     // ERP terceiro deverá passar             
                "cor_id": `${this.produto.cor_id}`,                                           
                "tamanho_id": `${this.produto.tamanho_id}`,                                        
                "funcionario_id": `${this.user.id_funcionario}`,                                              
                "filtro": 'inclusao'
            };
          const url = `${baseApiUrl}/sambaiba/cf7/produtocad`
            axios.post(url,corpo)
            .then(() => {                                                  
                    this.loadCliGrid()
                    this.$toasted.global.defaultSuccess()
                    this.reset()
                  })
            .catch(showError)
      }, 

      
      reset() {                  
            this.produto = {}
      },      
    },

    watch: {
      page() {
        this.loadVeiculos()
      }
    },

    mounted() {  
      this.loadEmpresas()
      this.loadCor()
      this.loadTamanho()      
      this.loadEscritório()
      this.loadCliGrid()      
      /*
      this.loadFiliais()
      this.loadVeiculos() 
      this.loadFabricanteChassi()            
      this.loadModeloChassi()
      this.loadcliforStatus()
      this.loadCarroceriaFabricante()
      this.loadCarroceriaModelo()     
      this.loadTamanhoFrota()
      this.loadLote()
      */

      
    },
}

</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>

#selecaostatusx{
    font-size: 0.7em;      
}

</style>
